import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  height: auto;
  z-index: 3;

  .close-button {
    color: rgba(0, 0, 0, 0.4);
    position: absolute;
    cursor: pointer;
    font-size: 1.4rem;
    right: 15px;
    top: 15px;

    @media screen and (min-width: 992px) {
      right: 30px;
      top: 20px;
    }

    &:hover {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .menu-container {
    background: #fff;
    width: 100%;

    .content {
      margin: 0 auto;
      width: 100%;
      max-width: 1200px;
      padding: 30px 12px;
      overflow: auto;
      height: calc(100vh - 60px);

      @media screen and (min-width: 992px) {
        overflow: unset;
        height: unset;
      }
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 3;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
`;
